import { Dropdown, IconButton } from '@anyemp/ui-kit';
import { MoreHorizontal } from 'lucide-react';

const CardActionsMenu = ({ children, label = 'More actions' }) => (
  <Dropdown
    portal
    variant="info"
    trigger={
      <IconButton
        icon={<MoreHorizontal className="h-5 w-5" />}
        aria-label={label}
        title={label}
        variant="ghost"
        color="neutral"
      />
    }
  >
    <div className="flex flex-wrap items-center gap-1 p-1">{children}</div>
  </Dropdown>
);

export default CardActionsMenu;
